import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useMobile from '@/hooks/useMobile';
import Timer from './Timer';

function SaturatedTimer({ tries = 3, disableTries = false, view = 'home' }) {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  return (
    <Box
      sx={{
        height: '60px',
        width: '100%',
        background: (theme) => theme.palette.grey[900],
        borderRadius: '10px',
        mb: 2,
        mt: isMobile ? 2 : 0,
        mr: isMobile ? 2 : 0,
        ml: isMobile ? 2 : 0,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{ height: '100%', p: 2 }}
      >
        <Box
          sx={{
            width: '90px',
            display: 'flex',
            justifyItems: 'center',
            alignItems: 'center',
            borderRight: (theme) => `solid 1px ${theme.palette.grey[600]}`,
          }}
        >
          <Timer />
        </Box>
        {!disableTries && (
          <Box>
            <Typography
              sx={{
                flex: 1,
                fontWeight: 400,
                color: '#FFF',
                fontSize: isMobile ? '12px' : '14px',
              }}
              variant="caption"
              component="div"
            >
              {t('checkout.home.saturated.timer')}
              <Typography
                sx={{
                  flex: 1,
                  fontWeight: 600,
                  color: '#FFF',
                  fontSize: isMobile ? '12px' : '14px',
                }}
                variant="caption"
                component="span"
              >
                {t('checkout.home.saturated.timer2', {
                  count: view === 'home' ? tries : tries - 1,
                })}
              </Typography>
              {t('checkout.home.saturated.timer3')}
            </Typography>
          </Box>
        )}
        {disableTries && (
          <Box>
            <Typography
              sx={{
                flex: 1,
                fontWeight: 400,
                color: '#FFF',
                fontSize: isMobile ? '12px' : '14px',
              }}
              variant="caption"
              component="div"
            >
              Evento saturado, cuentas con 3 minutos para realizar tu selección
              de boletos.
            </Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
}

export default SaturatedTimer;
